module.exports = __webpack_public_path__ + "static/img/pos_product_income.9a25c6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/pos_product_income.png
// module id = SjE3
// module chunks = 8